import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: '/',
      name: '::Menu:Home',
      iconClass: 'fa-solid fa-home',
      order: 0,
      layout: eLayoutType.application,
      invisible: true,
    },
    {
      path: '/projects',
      name: '::Menu:Projects',
      layout: eLayoutType.application,
      iconClass: 'fa-solid fa-file-lines',
      order: 1,
      requiredPolicy: 'Designer.Projects',
    },
    {
      path: '/saas',
      name: 'Saas::Menu:Saas',
      iconClass: 'fa-solid fa-users',
      order: 2,
      layout: eLayoutType.application,
      requiredPolicy: 'Saas.Tenants || Saas.Editions',
    },
    {
      path: '/integrations',
      iconClass: 'fa-solid fa-plug',
      name: '::Menu:Integrations',
      layout: eLayoutType.application,
      order: 3,
      requiredPolicy:
        'Designer.ChannelIntegrations || Designer.ServiceIntegrations || Designer.LlmConfigurations || Designer.McpServers',
    },
  ]);
};

export const APP_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];
